import React, {Component} from "react";
import {connect} from "react-redux";

import FramePanel from "../global/FramePanel";
import StatusPanel from "./welcome/StatusPanel";
import ModulePanel from "./welcome/ModulePanel";
import SimpleFooter from "../../containers/global/SimpleFooter";
import NotificationPanel from "../../containers/apps/default/NotificationPanel";

class Welcome extends Component {
    getWelcomeBody = () => {
        if (this.props.gammaSoftware && this.props.module === null) {
            return <ModulePanel />;
        }

        return (
            <div className="welcome-window">
                <div className="redlike-logo-blue" />
            </div>
        );
    };

    render() {
        return (
            <div style={{WebkitAppRegion: "drag"}}>
                <FramePanel />
                <div className="welcome">
                    {this.getWelcomeBody()}
                    <StatusPanel />
                    <NotificationPanel />
                    <SimpleFooter virtualKeyboardSupport={false} />
                </div>
            </div>
        );
    }
}

export default Welcome = connect((store) => {
    return {
        gammaSoftware: store.module.gammaSoftware,
        module: store.module.name
    };
})(Welcome);
